import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

export const useDeleteLesson = () => {
  const client = useApiClient();

  return useMutation<null, Error, { lessonID: number }>({
    mutationFn: ({ lessonID }) => client.deleteLesson(lessonID),
  });
};
